import React from 'react';
import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import SectionView from './SectionView';
import { sectionSchema } from './schema';

const SectionEdit = (props) => {
  const { data, block, onChangeBlock, selected } = props;
  const schema = sectionSchema();
  return (
    <>
      <SectionView data={data} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={schema}
          title={schema.title}
          onChangeField={(id, value) => onChangeBlock(block, { ...data, [id]: value })}
          onChangeBlock={onChangeBlock}
          formData={data}
          block={block}
        />
      </SidebarPortal>
    </>
  );
};
export default SectionEdit;
